<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => {
        return [];
      }
    }
  }
};
</script>

<template>
  <!-- start page title -->
  <div class="topbar-menu">
    <div class="container-fluid">
      <div class="page-title-box">
        <div class="page-title-right">
          <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
        </div>
        <h5 class="page-title">Portal do Cliente</h5>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
